import { Text2, Text3, skinVars } from '@telefonica/mistica';
import React from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';

const LoginHelpSignUp: React.FC = () => {
    const { t } = useTranslation();

    const storage = localStorage.getItem('storage');
    let storageJson: any;
    if (storage) {
        storageJson = JSON.parse(storage);
    }

    return (
        <div className='loginInformation-page'>
            {storageJson.title === t('titleModalToSignUp') && (
                <div className='loginInformation-page__singUp'>
                    <Text2 regular color={skinVars.colors.textSecondary}>
                        {t('contentModalSignUp')}
                    </Text2>
                </div>
            )}
            {storageJson.title === t('titleModalToAccess') && (
                <div className='loginInformation-page__access'>
                    <div className='loginInformation-page__access-itemOne'>
                        <div className='loginInformation-page__access-itemOne-title'>
                            <Text3 regular>{t('contentModalSingUpaccessWithPassword')}</Text3>
                        </div>
                        <Text2 regular color={skinVars.colors.textSecondary}>
                            {t('contentModalSingUpaccessWithPasswordText')}
                        </Text2>
                    </div>
                    <div className='loginInformation-page__access-itemTwo'>
                        <div className='loginInformation-page__access-itemTwo-title'>
                            <Text3 regular>{t('contentModalSingUpaccessWithMobile')}</Text3>
                        </div>
                        <Text2 regular color={skinVars.colors.textSecondary}>
                            {t('contentModalSingUpaccessWithMobileText')}
                        </Text2>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LoginHelpSignUp;
